import { GetDevicePaymentMethodAvailableFunc } from "src/common/experience/interface";
import { ApplePayPaymentMethod, GooglePayPaymentMethod } from "src/common/payment";

export const getToastApplePayAvailable: GetDevicePaymentMethodAvailableFunc<ApplePayPaymentMethod> = () =>
    Promise.resolve(true);

export const getToastGooglePayAvailable: GetDevicePaymentMethodAvailableFunc<GooglePayPaymentMethod> = () =>
    Promise.resolve(true);
